/** Extract a user-facing message from an A1 / axios API error. */
export function getApiErrorMessage(
  error: unknown,
  fallback = "Something went wrong. Please try again."
): string {
  if (typeof error === "string" && error.trim()) {
    return error.trim();
  }

  const response = (error as { response?: { data?: unknown } })?.response;
  const data = response?.data;
  const fromBody = extractMessageFromData(data);
  if (fromBody) {
    return fromBody;
  }

  if (
    error instanceof Error &&
    error.message &&
    !error.message.startsWith("Request failed") &&
    error.message !== "Network Error"
  ) {
    return error.message;
  }

  return fallback;
}

function extractMessageFromData(data: unknown): string | undefined {
  if (!data) {
    return undefined;
  }
  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }
  if (typeof data !== "object") {
    return undefined;
  }

  const record = data as Record<string, unknown>;
  const nested = record.error;
  const nestedRecord =
    typeof nested === "object" && nested !== null
      ? (nested as Record<string, unknown>)
      : undefined;

  const candidates = [
    record.message,
    typeof nested === "string" ? nested : nestedRecord?.message,
    nestedRecord?.detail,
    record.detail,
    Array.isArray(record.non_field_errors)
      ? record.non_field_errors[0]
      : undefined,
    record.success &&
    typeof record.success === "object" &&
    record.success !== null
      ? (record.success as Record<string, unknown>).message
      : undefined,
  ];

  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }

  return undefined;
}
